import React, { Component } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

class Button extends Component {
  render() {
    const { onClick, header, loading } = this.props

    return (
      <div
        className={'confirm_button'}
        onClick={() => {
          if (!loading) onClick()
        }}
        style={{
          marginTop: 25,
          height: 25,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {loading ? (
          <CircularProgress
            style={{ color: 'white' }}
            thickness={6}
            size={20}
          />
        ) : (
          header
        )}
      </div>
    )
  }
}

export { Button }



// WEBPACK FOOTER //
// ./src/components/common/Button.js